// React & Redux Imports
import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Material UI Imports
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';

// Project Imports
import styles from './styles';
import ReactTippyWrapper from '../../components/ReactTippyWrapper';
import ResponsiveNav from './ResponsiveNav';
import { openSignUpForm, openLoginForm } from '../AuthModal/actions';
import { openDrawingTool } from '../DrawingTool/actions';
import { logout } from '../Authenticator/actions';
import ResponsiveLogo from '../../components/LogoComponent';
import LevelDots from '../../components/levelDots';

// Assets import
import blogIcon from '../../assets/images/blog.svg';
import help from '../../assets/images/help.jpg';
import explore from '../../assets/images/explore1.svg';
import notification from '../../assets/images/notification.svg';
import reply from '../../assets/images/startThread.svg';

import './index.scss';

const Navbar = (props) => {
  const {
    classes, logout, openSignUpForm, openLoginForm, isAuthenticated, userPhoto, username, openDrawingTool,
    userId, level, authAction, logoutAction,
  } = props;

  let userView;
  if (!isAuthenticated) {
    userView = (
      <div>
        <Button
          className={classes.btn}
          onClick={() => {
            openSignUpForm();
          }}
        >
          Sign Up
        </Button>
        <Button
          className={classes.btnWhite}
          onClick={() => {
            openLoginForm();
          }}
        >
          Log In
        </Button>
      </div>
    );
  } else {
    userView = (
      <div>
        <ReactTippyWrapper
          interactive="true"
          position="left"
          distance="0"
          html={(
            <div>
              <Button
                className="btnYellow"
                onClick={() => {
                  logout();
                }}
              >
                Logout
              </Button>
            </div>
          )}
        >
          <Link to={{
            pathname: '/user',
            search: userId,
          }}
          >
            <Button
              className="profileBtn"
            >
              <img alt={username} src={userPhoto} />
            </Button>
          </Link>,
          <LevelDots
            level={level}
            trail
          />
        </ReactTippyWrapper>
        <Button className="btnEdit">
          <img alt="" src={notification} />
        </Button>
      </div>
    );
  }
  return (
    <div>
      <ResponsiveNav
        authAction={authAction}
        logoutAction={logoutAction}
      />
      <Hidden xsDown>
        <AppBar position="fixed" className={classes.headerMain}>
          <ResponsiveLogo />
        </AppBar>
      </Hidden>
      <Hidden xsDown>
        <div className="sidebar">
          {/* hidePanel */}
          <div className="wrapper vCenterSpaceBetween height-full">
            <div>
              {userView}
              <Button className="btnEdit">
                <img alt="" src={explore} />
              </Button>
              <Button className="btnEdit" onClick={() => { openDrawingTool(false, 0, 0, 'My Title'); }}>
                <img alt="" src={reply} />
              </Button>
            </div>
            <div className="footerLinks">
              <Button className="btnedit">
                <img alt="" src={blogIcon} />
              </Button>
              <Button className="btnedit">
                <img src={help} alt="" />
              </Button>
              {/* <Button className="btnedit closeNav" /> */}
            </div>
          </div>
          {/* <Button className="hamburgerMenu" /> */}
        </div>
      </Hidden>
    </div>
  );
};

Navbar.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  openLoginForm: PropTypes.func.isRequired,
  openSignUpForm: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  username: PropTypes.string,
  userPhoto: PropTypes.string,
  userId: PropTypes.string,
};

Navbar.defaultProps = {
  username: null,
  userPhoto: null,
  userId: null,
};

const navbarWithStyles = withStyles(styles)(Navbar);

const mapStateToProps = (state, props) => ({
  isAuthenticated: state.authenticationStatus.get('isAuthenticated'),
  userPhoto: state.authenticatedUserDetails.get('photo'),
  username: state.authenticatedUserDetails.get('name'),
  level: state.authenticatedUserDetails.get('level'),
  userId: state.authenticatedUserDetails.get('userId'),
  authAction: props.authAction,
  logoutAction: props.logoutAction,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  openSignUpForm: () => {
    dispatch(openSignUpForm(ownProps.authAction));
  },
  openDrawingTool: (isReply, previousActivityId, vcId, title) => {
    dispatch(openDrawingTool(isReply, previousActivityId, vcId, title));
  },
  openLoginForm: () => {
    dispatch(openLoginForm(ownProps.authAction));
  },
  logout: () => {
    dispatch(logout(ownProps.logoutAction));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(navbarWithStyles);



// WEBPACK FOOTER //
// ./src/containers/Navbar/index.js